import React, { useState, useEffect, useRef } from 'react';
import { ButtonGroup, Button, Grid } from "@material-ui/core";
import { useVideo } from '../../api/VideoProvider';
import { Add, Remove, Send } from '@material-ui/icons';
import { pRecordTime, pStatus } from '../../utils/parameters';
import useMediaQuery from '@mui/material/useMediaQuery';
import { pVisualControl } from '../../utils/parameters';
import { useTranslation } from "react-i18next";
import { useStreamProvider } from '../../api/StreamProvider';
import { useTimerProvider } from '../../api/TimerProvider';
import { CountdownTimer } from './CountdownTimer';
import { useMediapipeHolisticProvider } from '../../api/MediapipeHolisticProvider';


export function RecordingButtons(props) {
    const { stream, action_btn_send, action_btn_repeat, customTimer, record_video, record_mediapipe, record_trigger, setOpenCameraTester, required_revision } = props;
    const [ countDownTimerActive, setCountDownTimerActive ] = useState(false);

    const { t } = useTranslation("global")

    const [timerStart, setTimerStart] = useState(pRecordTime.default);
    const [timerMax, setTimerMax] = useState(pRecordTime.max);
    const [timerMin, setTimerMin] = useState(pRecordTime.min);
    const [timerStep, setTimerStep] = useState(pRecordTime.step);

    const { 
        timer, 
        timerActive, 
        setConfigTimer, 
        stopTimer ,
        timerSpeed
    } = useTimerProvider();

    const { 
        streamMediaBlobUrl, 
        setStreamMediaBlobUrl, 
        getStreamIsRecording, 
        streamInitRecording, 
        streamStartRecording, 
        streamPauseRecording, 
        streamStopRecording 
    } = useStreamProvider();
    
    const { 
        getMediapipeHolisticDataBuffer, 
        clearMediapipeHolisticDataBuffer, 
        startMediapipeHolisticDataBufferRecord, 
        stopMediapipeHolisticDataBufferRecord 
    } = useMediapipeHolisticProvider();

    /* MOB - Nav responsiveness*/
    const queryChecks = {
        textWidthLimit: useMediaQuery('(max-width:260px)'),
    }

    useEffect(() => {
        if (stream){
            streamInitRecording(stream)
        }
        return () => {
            setStreamMediaBlobUrl(undefined)
            stopTimer()
        }
    }, [stream])

    useEffect(() => {
        console.log("🚀 ~ RecordingButtons ~ customTimer:", customTimer)
        if (customTimer!==undefined){
            setTimerStart(customTimer['timer'])
            setTimerMax(customTimer['max'])
            setTimerMin(customTimer['min'])
            setTimerStep(customTimer['step'])
        }
    }, [customTimer])
    


    function startRecording() {
        console.log("🚀 ~ startRecording ~ startRecording:", startRecording)
        
        if (record_video){
            streamStartRecording()
        }
        if (record_mediapipe){
            clearMediapipeHolisticDataBuffer();
            startMediapipeHolisticDataBufferRecord();
        }
        startRecordingTimer()
    }

    function repeatRecording() {
        console.log("🚀 ~ repeatVideo ~ repeatRecording:", repeatRecording)
        stopRecording()
        setStreamMediaBlobUrl(undefined)

        if (action_btn_repeat !== undefined){
            action_btn_repeat()
        }
    }

    function stopRecording(){
        if (record_video){
            streamStopRecording();
        }
        if (record_mediapipe){
            stopMediapipeHolisticDataBufferRecord();
        }
    }

    function downloadBlob() {
        const a = document.createElement('a');
        a.href = streamMediaBlobUrl;
        console.log("🚀 ~ downloadBlob ~ streamMediaBlobUrl:", streamMediaBlobUrl)
        const now = new Date();
        const fileName = `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}-${now.getHours()}-${now.getMinutes()}-${now.getSeconds()}.mp4`;    
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
            // window.URL.revokeObjectURL(url);
        }, 0);
    };

    function downloadBlobMediapipe() {
        const jsonData = JSON.stringify(getMediapipeHolisticDataBuffer());
        const blob = new Blob([jsonData], { type: 'application/json' });
        const fileData = new File([ blob ], 'data.json');
        const bloblurl = URL.createObjectURL(blob);
        console.log("🚀 ~ downloadBlobMediapipe ~ bloblurl:", bloblurl)

        const a = document.createElement('a');
        a.href = bloblurl;
        console.log("🚀 ~ downloadBlob ~ bloblurl:", bloblurl)
        
        const now = new Date();
        const fileName = `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}-${now.getHours()}-${now.getMinutes()}-${now.getSeconds()}.json`;    
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
            // window.URL.revokeObjectURL(url);
        }, 0);
    };


    /* Manage +/- buttons */
    function increaseTimer() {
        timerStart >= timerMax ? setTimerStart(timerMax) : setTimerStart(timerStart + timerStep);
    }

    function decreaseTimer() {
        timerStart <= timerMin ? setTimerStart(timerMin) : setTimerStart(timerStart - timerStep);
    }

    function disabled_start_cancel_btn(){
        return streamMediaBlobUrl === undefined ? false : true
    }
    function disabled_repeat_btn(){
        return streamMediaBlobUrl === undefined ? true : false
    }
    function disabled_send_btn(){
        // return false
        return streamMediaBlobUrl === undefined ? true : false
    }


    // function startRecordingTimer(){
    //     setConfigTimer({
    //         'label': 'Recording',
    //         'start': timerStart,
    //         'end': 0,
    //         'step': timerStep,
    //         'interval_ms': 1000,
    //         'onEnd': () => stopRecording()
    //     })
    // }

    function startRecordingTimer(){
        setConfigTimer({
            'label': 'Recording',
            'start': timerStart,
            'end': 0,
            'step': timerStep,
            'interval_ms': 1000,
            'onEnd': () => stopRecording()
        })
    }

    function startCountdownTimer(){
        console.log("🚀 ~ CountdownTimer ~ startCountdownTimer:", startCountdownTimer)
        setCountDownTimerActive(true)
        setConfigTimer({
            'label': 'Countdown',
            'start': 4,
            'end': 0,
            'step': 1,
            'interval_ms': 1000,
            'onEnd': () => {setCountDownTimerActive(false), startRecording()}
        })
    }

    function endCountdownTimer(){
        console.log("🚀 ~ CountdownTimer ~ endCountdownTimer:", endCountdownTimer)
        setCountDownTimerActive(false)
    }

    useEffect(() => {
        console.log('Timer provider - timer: ', timer)
    }, [timer]);

    useEffect(() => {
        console.log('Timer provider - timerActive: ', timerActive)
    }, [timerActive]);

    useEffect(()=>{
        if (record_trigger!==null){
            startCountdownTimer()
        }
    },[record_trigger])

    return (
        <>
            {countDownTimerActive && <CountdownTimer/>}
            <Grid container className='sig_Home_ButtonsContainerInner'>            
                {props.children}
                
                <Grid item>
                    <ButtonGroup className='sig_Home_RecordingButtons' variant="contained" color="primary">

                        { getStreamIsRecording() === false ? (
                            required_revision == false ? (
                                <Button data-tour='tourCam_5' onClick={startCountdownTimer} disabled={disabled_start_cancel_btn()}>{t("sRecordComponent.recordButton")}</Button>
                            ) : (
                                <Button data-tour='tourCam_5' onClick={() => setOpenCameraTester(true)} disabled={disabled_start_cancel_btn()}> {t("sRecordComponent.recordButton")}</Button>
                            )
                        ) : (
                            <Button data-tour='tourCam_5' onClick={stopTimer} disabled={disabled_start_cancel_btn()}> Detener </Button>
                        )
                        }
                        <Button data-tour="tourCam_7b" onClick={repeatRecording} disabled={disabled_repeat_btn()}> {t("sRecordComponent.repeatButton")} </Button>
                    </ButtonGroup>
                </Grid>

                <Grid item>
                    <ButtonGroup disabled={customTimer['blocked']===true} data-tour='tourCam_3' className='sig_Home_TimerButtons' variant="contained" color="primary">
                        <Button startIcon={<Remove />} onClick={decreaseTimer}></Button>
                        <Button data-tour='tourCam_6' > {(timerStart * timerSpeed).toFixed(1)} {queryChecks.textWidthLimit ? <> {t("sRecordComponent.sec")} </> : <> {t("sRecordComponent.seconds")}</> }</Button>
                        <Button startIcon={<Add />} onClick={increaseTimer}></Button>
                    </ButtonGroup>
                </Grid>

                
                <Grid item>
                    <Button data-tour='tourCam_8' className='sig_Home_SendButton' variant="contained" color="primary" endIcon={<Send />} onClick={action_btn_send} disabled={disabled_send_btn()}>
                        Enviar
                    </Button>
                </Grid>
                {/* <Grid item className='sig_Home_RecordingButtons_Send'>
                    <Button data-tour='tourCam_8' className='sig_Home_SendButton' variant="contained" color="primary" endIcon={<Send />} onClick={downloadBlob} disabled={disabled_send_btn()}>
                        DESCARGA
                    </Button>
                </Grid>
                <Grid item className='sig_Home_RecordingButtons_Send'>
                    <Button data-tour='tourCam_8' className='sig_Home_SendButton' variant="contained" color="primary" endIcon={<Send />} onClick={downloadBlobMediapipe} disabled={disabled_send_btn()}>
                        DESCARGA MEDIAPIPE
                    </Button>
                </Grid> */}
            </Grid >
        </>

    )
}